import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import CourseSectionService from "../../src/Services/CourseSection.service";
const CourseSectionLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return CourseSectionService.search({ ids: ids }).then(({ data }) => data);
        },
        fetchOptions: (query) => {
            return CourseSectionService.search({
                query,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(courseSection) {
            return _jsx("span", { children: courseSection.fullName });
        },
    });
};
export default CourseSectionLookup;
